import React from 'react'
import {
  presenceErrorClass,
} from 'servos/formValidations'
import Card from '../../../commons/Card'

class ContactDetails extends React.Component {
  render() {
    const {
      errorMessage,
      email,
      mobile,
      handleInput,
    } = this.props

    return (
      <Card
        iconName='plane'
        title='Contact details'
      >
        <div className='card-body'>
          <div className='row'>
            <div className='col col-sm-8'>
              <div className='form-group'>
                <label>Email address</label>
                <input className='form-control' disabled value={email}/>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col col-sm-8'>
              <div className='form-group'>
                <label>Mobile phone number</label>
                <input
                  id='mobile'
                  onChange={handleInput}
                  className={`form-control ${presenceErrorClass(errorMessage)}`}
                  value={mobile}
                  type='numeric'
                />
                <div className="invalid-feedback">
                  { errorMessage }
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    )
  }
}

export default ContactDetails;
